import React, { useEffect } from 'react';
import { ConfirmationNumber } from '@mui/icons-material';
import { Box } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IFormato, IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { TipoGenerico } from 'utils/models/types';
import { fetchGrillaEspectaculos } from 'utils/redux/features/espectaculosGrillaSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { crearOpcionesTipos } from 'utils/utilities';
import { anchoMaxLogueado } from 'utils/constants';

const CompraAdmin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { grillaEspectaculos, loadingGrillaEspectaculos, errorGrillaEspectaculos } = useSelector(
    (state: RootState) => state.espectaculosGrilla
  );
  const nombresEspectaculos: TipoGenerico[] = grillaEspectaculos.map(e => {
    return { Nombre: e?.Nombre, Id: e?.Id };
  });

  const opcionesEspectaculos: ISelectOptions[] = crearOpcionesTipos(nombresEspectaculos, 'Id');
  const datosEspectaculos: IFormato<TipoGenerico>[] = [
    {
      name: 'Id',
      label: 'Seleccionar espectáculo',
      inputType: 'select',
      defaultValue: opcionesEspectaculos[0]?.id,
      subtituloSeccion: 'Agregar compra de entradas que fueron realizadas por otro canal',
    },
  ];

  useEffect(() => {
    dispatch(fetchGrillaEspectaculos());
  }, [dispatch]);

  const handleSubmit = (data: IFormulario) => {
    const { Id } = data;
    navigate(`/espectaculos/${Id}`);
  };

  return (
    <Box maxWidth={anchoMaxLogueado} mx="auto">
      {loadingGrillaEspectaculos ? (
        <Spinner />
      ) : errorGrillaEspectaculos ? (
        <NoResponse />
      ) : (
        <Formulario
          campos={datosEspectaculos}
          datos={opcionesEspectaculos}
          iconoBoton={ConfirmationNumber}
          textoBoton="Comprar entradas"
          onSubmit={handleSubmit}
          mensajeExito=""
          titulo="Comprar entradas"
        />
      )}
    </Box>
  );
};

export default CompraAdmin;
